import React from "react";
import styled from "styled-components";
import { ButtonToolbar } from "components/bootstrap";
import FilterRuleEditButton from "components/streams/StreamDetails/output-filter/FilterRuleEditButton";
import FilterDeleteButton from "components/streams/StreamDetails/output-filter/FilterDeleteButton";
const StyledButtonToolbar = styled(ButtonToolbar)`
  justify-content: flex-end;
`;
const FilterActions = ({ filterRule, destinationType }) => /* @__PURE__ */ React.createElement(StyledButtonToolbar, null, /* @__PURE__ */ React.createElement(FilterRuleEditButton, { filterRule, destinationType, streamId: filterRule.stream_id }), /* @__PURE__ */ React.createElement(FilterDeleteButton, { streamId: filterRule.stream_id, filterOutputRule: filterRule }));
export default FilterActions;
